"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchService = void 0;
const net = require("@ivanlog/net");
const models_1 = require("./models");
const models_2 = require("./models");
const models_3 = require("./models");
class SearchService {
    /**
    * @param {net.HTTPClient} _client -
    * @param {(e: unknown, args?: unknown) => void} _errorsHandler -
    */
    constructor(_client, _errorsHandler) {
        this._client = _client;
        this._errorsHandler = _errorsHandler;
        if (!this._errorsHandler)
            this._errorsHandler = (e, args) => { throw e; };
    }
    /**
    * @param {SearchService_SetSynonyms_Request} bodyData -
    * @returns {Promise<NBResult|OkResult|net.NetError|number>}
    */
    setSynonymsUnsafe(bodyData) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/SearchService/SetSynonyms";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __url = __endpoint;
            let __data;
            if (typeof bodyData === "object")
                __data = net.def.objToClearJSON(bodyData);
            const __response = yield this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200]);
            const __code = __response.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.OkResult(yield __response.json());
                        break;
                    case 401:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 403:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 422:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 500:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * @param {SearchService_SetSynonyms_Request} bodyData -
    * @param {unknown} errHndlArgs? - args for errorsHandler
    * @returns {Promise<OkResult|undefined>}
    */
    setSynonyms(bodyData, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.setSynonymsUnsafe(bodyData);
                if (!(r instanceof models_1.OkResult))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    getSynonymsUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/SearchService/GetSynonyms";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __url = __endpoint;
            const __response = yield this._client.process(net.HTTPMethods.GET, __url, undefined, __addHeaders, [200]);
            const __code = __response.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        const __resultArr = yield __response.json();
                        __result = [];
                        for (const __r of __resultArr)
                            __result.push(new models_3.KeywordPair(__r));
                        break;
                    case 401:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 403:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 422:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 500:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * @param {unknown} errHndlArgs? - args for errorsHandler
    * @returns {Promise<Array<KeywordPair>|undefined>}
    */
    getSynonyms(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.getSynonymsUnsafe();
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * @param {SearchService_SetTypos_Request} bodyData -
    * @returns {Promise<NBResult|OkResult|net.NetError|number>}
    */
    setTyposUnsafe(bodyData) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/SearchService/SetTypos";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __url = __endpoint;
            let __data;
            if (typeof bodyData === "object")
                __data = net.def.objToClearJSON(bodyData);
            const __response = yield this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200]);
            const __code = __response.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.OkResult(yield __response.json());
                        break;
                    case 401:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 403:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 422:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 500:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * @param {SearchService_SetTypos_Request} bodyData -
    * @param {unknown} errHndlArgs? - args for errorsHandler
    * @returns {Promise<OkResult|undefined>}
    */
    setTypos(bodyData, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.setTyposUnsafe(bodyData);
                if (!(r instanceof models_1.OkResult))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    getTyposUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/SearchService/GetTypos";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __url = __endpoint;
            const __response = yield this._client.process(net.HTTPMethods.GET, __url, undefined, __addHeaders, [200]);
            const __code = __response.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        const __resultArr = yield __response.json();
                        __result = [];
                        for (const __r of __resultArr)
                            __result.push(new models_3.KeywordPair(__r));
                        break;
                    case 401:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 403:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 422:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 500:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * @param {unknown} errHndlArgs? - args for errorsHandler
    * @returns {Promise<Array<KeywordPair>|undefined>}
    */
    getTypos(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.getTyposUnsafe();
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * @param {SearchService_SetMisspellings_Request} bodyData -
    * @returns {Promise<NBResult|OkResult|net.NetError|number>}
    */
    setMisspellingsUnsafe(bodyData) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/SearchService/SetMisspellings";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __url = __endpoint;
            let __data;
            if (typeof bodyData === "object")
                __data = net.def.objToClearJSON(bodyData);
            const __response = yield this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200]);
            const __code = __response.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.OkResult(yield __response.json());
                        break;
                    case 401:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 403:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 422:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 500:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * @param {SearchService_SetMisspellings_Request} bodyData -
    * @param {unknown} errHndlArgs? - args for errorsHandler
    * @returns {Promise<OkResult|undefined>}
    */
    setMisspellings(bodyData, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.setMisspellingsUnsafe(bodyData);
                if (!(r instanceof models_1.OkResult))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    getMisspellingsUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/SearchService/GetMisspellings";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __url = __endpoint;
            const __response = yield this._client.process(net.HTTPMethods.GET, __url, undefined, __addHeaders, [200]);
            const __code = __response.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        const __resultArr = yield __response.json();
                        __result = [];
                        for (const __r of __resultArr)
                            __result.push(new models_3.KeywordPair(__r));
                        break;
                    case 401:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 403:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 422:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 500:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * @param {unknown} errHndlArgs? - args for errorsHandler
    * @returns {Promise<Array<KeywordPair>|undefined>}
    */
    getMisspellings(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.getMisspellingsUnsafe();
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * @param {SearchService_Feed_Request} bodyData -
    * @returns {Promise<NBResult|OkResult|net.NetError|number>}
    */
    feedUnsafe(bodyData) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/SearchService/Feed";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __url = __endpoint;
            let __data;
            if (typeof bodyData === "object")
                __data = net.def.objToClearJSON(bodyData);
            const __response = yield this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200]);
            const __code = __response.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.OkResult(yield __response.json());
                        break;
                    case 401:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 403:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 422:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 500:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * @param {SearchService_Feed_Request} bodyData -
    * @param {unknown} errHndlArgs? - args for errorsHandler
    * @returns {Promise<OkResult|undefined>}
    */
    feed(bodyData, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.feedUnsafe(bodyData);
                if (!(r instanceof models_1.OkResult))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * @param {SearchService_SearchProductsIds_Request} bodyData -
    * @returns {Promise<NBResult|Array<number>|net.NetError|number>}
    */
    searchProductsIdsUnsafe(bodyData) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/SearchService/SearchProductsIds";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __url = __endpoint;
            let __data;
            if (typeof bodyData === "object")
                __data = net.def.objToClearJSON(bodyData);
            const __response = yield this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200]);
            const __code = __response.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        const __resultArr = yield __response.json();
                        __result = [];
                        for (const __r of __resultArr)
                            __result.push(__r);
                        break;
                    case 401:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 403:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 422:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    case 500:
                        __result = new models_2.NBResult(yield __response.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * @param {SearchService_SearchProductsIds_Request} bodyData -
    * @param {unknown} errHndlArgs? - args for errorsHandler
    * @returns {Promise<Array<number>|undefined>}
    */
    searchProductsIds(bodyData, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.searchProductsIdsUnsafe(bodyData);
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
}
exports.SearchService = SearchService;
//# sourceMappingURL=SearchService.js.map